import React from 'react';
import PublicPageWrapper from '../../components/PublicPageWrapper';
import { Trophy, Music, Cpu, Palette, Users, Heart } from 'lucide-react';

const activities = [
  { icon: Trophy, name: 'Sports & Fitness', items: ['Soccer', 'Netball', 'Athletics', 'Swimming'], desc: 'Our learners enjoy a range of sports in a fun, supportive setting - building fitness, teamwork, and school pride.' },
  { icon: Music, name: 'Music & Performance', items: ['Choir', 'Drama', 'Dance', 'Recitals'], desc: 'From school concerts to class performances, every child has the chance to find their voice and shine on stage.' },
  { icon: Cpu, name: 'STEM & Discovery', items: ['Coding Club', 'Science Projects', 'Maths Challenges'], desc: 'Hands-on technology and science activities that spark curiosity and creative problem-solving.' },
  { icon: Palette, name: 'Arts & Crafts', items: ['Art Club', 'Painting', 'Crafts', 'Exhibitions'], desc: 'Creative expression through drawing, painting, and craft - with regular displays of student artwork around campus.' },
  { icon: Users, name: 'Leadership & Speaking', items: ['Student Council', 'Debate', 'Public Speaking'], desc: 'Building confidence and critical thinking through student-led initiatives and speaking opportunities.' },
  { icon: Heart, name: 'Community & Values', items: ['Outreach Projects', 'Peer Tutoring', 'Cultural Days'], desc: 'Instilling empathy, kindness, and a sense of responsibility through community-focused activities.' },
];

export default function CampusLifePage() {
  return (
    <PublicPageWrapper title="Campus Life" subtitle="A close-knit school community where every child is encouraged to explore, grow, and belong.">
      <div data-testid="campus-life-page">
        <p className="text-slate-600 text-sm leading-relaxed mb-8 max-w-2xl">
          At Tadam Academy, campus life is about more than the classroom. In our small, focused environment, every learner has the opportunity to try new things, discover hidden talents, and build lasting friendships - all within a safe, supportive school family.
        </p>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mb-10">
          {activities.map(a => (
            <div key={a.name} className="bg-white rounded-xl border border-slate-100 p-6 hover:shadow-md hover:border-[#E8A830]/30 transition-all">
              <div className="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center mb-4">
                <a.icon className="w-5 h-5 text-[#E8A830]" />
              </div>
              <h3 className="font-bold text-[#1B2A4A] mb-2">{a.name}</h3>
              <p className="text-sm text-slate-500 mb-4">{a.desc}</p>
              <div className="flex flex-wrap gap-1">{a.items.map(item => (
                <span key={item} className="bg-slate-50 text-slate-500 text-xs px-2 py-0.5 rounded-full">{item}</span>
              ))}</div>
            </div>
          ))}
        </div>
        <div className="bg-slate-50 rounded-2xl p-8 text-center">
          <h2 className="text-lg font-bold text-[#1B2A4A] mb-3">Every Child Gets a Chance</h2>
          <p className="text-sm text-slate-600 max-w-2xl mx-auto leading-relaxed">Because we are a small school, there are no benchwarmers at Tadam. Every student participates, every voice is heard, and every talent is celebrated. That is the Tadam difference.</p>
        </div>
      </div>
    </PublicPageWrapper>
  );
}
